/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

function polishCitywideFooter() {
  const footerContent = document.querySelector('footer .footer-content');

  if (!footerContent || footerContent.dataset.citywidePolished === 'true') {
    return;
  }

  const heading = footerContent.querySelector('h2, h3, h4');
  const paragraph = footerContent.querySelector('p');

  if (heading && /join our email list/i.test(heading.textContent || '')) {
    heading.textContent = 'Deals and restock reminders';
  }

  if (paragraph && /exclusive deals|early access/i.test(paragraph.textContent || '')) {
    paragraph.textContent = 'Get useful store updates, product availability notes and supply offers.';
  }

  if (!footerContent.querySelector('.cwt-native-footer-links')) {
    const links = document.createElement('nav');
    links.className = 'cwt-native-footer-links';
    links.setAttribute('aria-label', 'Footer store links');
    links.innerHTML = [
      '<div><h3>Shop</h3><a href="/search?type=product&q=">All products</a><a href="/search?type=product&q=*&filter.p.tag=collection%3APrinter%20Consumables">Toner and ink</a><a href="/search?type=product&q=*&filter.p.tag=collection%3APrinters">Printers</a><a href="/search?type=product&q=*&filter.p.tag=collection%3ANetworking%20%26%20Wi-Fi">Networking &amp; Wi-Fi</a></div>',
      '<div><h3>Help</h3><a href="/pages/contact">Contact store support</a><a href="/policies/shipping-policy">Shipping</a><a href="/policies/refund-policy">Returns</a><a href="/policies/privacy-policy">Privacy</a></div>',
    ].join('');
    footerContent.appendChild(links);
  }

  footerContent.dataset.citywidePolished = 'true';
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', polishCitywideFooter, { once: true });
} else {
  polishCitywideFooter();
}
